import React from "react";
import type { User } from "../apiClient/models/User";

export interface UserContextValue {
  user: User | null;
  isUserLoading: boolean;
  setUser: (user: User | null) => void;
}

const UserContext = React.createContext<UserContextValue>({
  user: null,
  isUserLoading: true,
  setUser: () => {},
});

export default UserContext;
